export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11270.377cd983.jpg";